import axios from 'axios';
/**
 * @name OAUTH
 * @description
 * Authentication Handler
 */
export default class OAUTH {

    constructor() {
        this.C = {
            API:{
                ecommerce: window.mmkt.config.API.ecommerce,
                jwt: window.mmkt.config.API.jwt
            }
        }
    }

    async getToken(conf = {}) {
        try {
            // Set OAuth client conf
            if(!Object.keys(conf).length || !conf.client_id || !conf.client_secret) throw 'Requiere conf of client with client_id and client_secret';

            let token = mmkt.core.storage.getItem(conf.client_id.toLowerCase()) || null;
            if(token && (typeof token === 'string' || token instanceof String)) return token;

            // Get JWT Authetication Token from API
            token = await axios({
                    method: 'post',
                    baseURL: this.C.API.jwt,
                    data: {
                        client_id: conf.client_id,
                        client_secret: conf.client_secret,
                    }
                });

            if(token.status === 200) mmkt.core.storage.setItem(conf.client_id.toLowerCase(), token.data, 20);
            return token.data;
        } catch (err) {
            console.info(`OAUTH | getToken | Error ${err}`);
        }
    }

    clearToken(){
        mmkt.core.storage.deleteItem(conf.client_id.toLowerCase());
    }
}